<template>
<div class="set-password-content">
  <v-form ref="form"
          class="password-setup-form"
          @submit.prevent
  >
    <VuePassword
        v-model="password"
        :strength="strength"
        class="password-field"
    >
    </VuePassword>
    <v-container class="strength-message" :class="strengthMessageClass">
      <v-row align="center" justify="center" class="password-strength"><v-col>
          {{ strengthMessage }}
      </v-col></v-row>
    </v-container>
    <div fluid class="password-requirements">
      <ul>
        <li :class="{ done: requirements.length }">
          {{ passwordMinimumLength }} characters minimum
        </li>
        <li :class="{ done: requirements.strength }">
          Minimum password strength: Strong Password
          <ul>
            <li class="suggestion" v-for="tip in strengthTips">{{ tip }}</li>
          </ul>
        </li>
      </ul>
    </div>

  </v-form>
</div>
</template>
<script>
import ConfigService from '../../services/config.service';
import zxcvbn from "zxcvbn";
import VuePassword from 'vue-password';

const strengthMessages = [
  "Very Weak Password",
  "Weak Password",
  "Medium Password",
  "Strong Password",
  "Very Strong Password"
];
export default {
  data () {
    return {
      showPassword: false,
      password: '',
      strength: 0,
      strengthMessageSet: false,
      strengthMessage: strengthMessages[0],
      strengthTips: [],
      requirements: {
        length: false,
        strength: false
      }
    }
  },
  components: {
    VuePassword
  },
  computed: {
    strengthMessageClass: function() {
      return this.strengthMessageSet ? '' : 'hide-me';
    },
    requirementsMet: function() {
      return this.requirements.length;
    },
    passwordMinimumLength: {
      get() {
        return ConfigService.getInstance().getPasswordMinimumLength();
      }
    }
  },
  methods: {
    updateStrength: function(strength) {
      this.strength = strength.score;
      this.requirements.strength = strength.score > 2;
      this.strengthTips = strength.feedback.suggestions;
      this.strengthMessage = strengthMessages[strength.score];
      this.strengthMessageSet = true;
    },
    changeHandler: function(val) {
      this.requirements.length = val.length >= this.passwordMinimumLength;
      this.strengthMessageSet = true;
      if (this.requirements.length && this.requirements.strength) {
        this.$emit('password-updated', val);
      } else {
        this.$emit('password-updated', '');
      }
    },
  },
  watch: {
    password: function(val) {
      this.updateStrength(zxcvbn(val));
      this.changeHandler(val);
    }
  }
};
</script>
<style scoped lang="scss">
  .set-password-content {
    margin: auto;

    .password-setup-form {
      min-height: 184px;
      .password-icon {
        cursor: pointer;
        color: var(--soft-text-color);
        margin-top: 2px;

        &.eye {
          margin-right: 1px;
        }

        &.hidden {
          display: none;
        }
      }

      .overridden-password-field {
        margin: 0;
        width: 100%;
      }
    }

    .strength-message {
      margin-top: 5px;
      padding: 12px;
    }

    .hide-me {
      visibility: hidden;
    }

    .password-strength {
      font-size: 12px;
      font-weight: 800;
      line-height: 24px;
      color: var(--soft-text-color);
      padding: 0;
    }

    .password-recommendations {
      margin-top: 10px;
      font-size: 12px;
      line-height: 24px;
      color: var(--soft-text-color);
      padding: 0;
    }

    .password-requirements {
      font-size: 12px;
      line-height: 24px;

      > ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          color: var(--bad-color);
        }

        li.done {
          color: var(--good-color);
        }
      }
    }

    .special-character-tooltip {
      font-size: 12px;
      line-height: 18px;
    }

    .btn-container {
      max-width: 300px;
      margin: 0 auto;
    }
  }
  
</style>
<style>
.VuePassword__Meter {
  margin-top: 5px;
}
.VuePassword__Container {
  height: 50px;
}

.VuePassword__Input {
  border-color: var(--stroke-decorative-default);
  border-radius: var(--text-input-border-radius);
  color: #6D787E;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  height: 100%;
}
.VuePassword--weak {
    color: var(--bad-color);
}
.VuePassword--medium {
    color: var(--bad-color);
}
.VuePassword--great {
    color: var(--good-color);
}
</style>